import { BaseService } from "./BaseService";
import {
  ConfigureAppleProviderRequest,
  ConfigureGoogleProviderRequest,
  ConfigureProviderResponse,
  RemoveProviderResponse,
  SsoProviderAlias,
  SsoSettingsResponse,
} from "@/types/sso";

class SsoSettingsService extends BaseService {
  private basePath(tenantId: string): string {
    return `/admin/tenants/${tenantId}/sso-settings`;
  }

  async getSettings(tenantId: string): Promise<SsoSettingsResponse> {
    return this.get<SsoSettingsResponse>(this.basePath(tenantId));
  }

  async configureGoogle(
    tenantId: string,
    payload: ConfigureGoogleProviderRequest,
  ): Promise<ConfigureProviderResponse> {
    return this.put<ConfigureProviderResponse>(
      `${this.basePath(tenantId)}/providers/google`,
      payload,
    );
  }

  async configureApple(
    tenantId: string,
    payload: ConfigureAppleProviderRequest,
  ): Promise<ConfigureProviderResponse> {
    return this.put<ConfigureProviderResponse>(
      `${this.basePath(tenantId)}/providers/apple`,
      payload,
    );
  }

  async removeProvider(
    tenantId: string,
    provider: SsoProviderAlias,
  ): Promise<RemoveProviderResponse> {
    return this.delete<RemoveProviderResponse>(
      `${this.basePath(tenantId)}/providers/${provider}`,
    );
  }
}

export const ssoSettingsService = new SsoSettingsService();
